import urljoin from 'url-join'

export function initApi (axios) {
  return {
    fetchNationalCouncilCategory () {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/wp/v2/nc-category')
          .then((response) => {
            if (response.status === 200) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    submitCampaign ({ title, description }) {
      return new Promise((resolve, reject) => {
        axios.post('/wp-json/wp/v2/campaigns', { title, content: description })
          .then((response) => {
            if (response.status === 201) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchQuestionnaires () {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/dabg/v1/questionnaires/')
          .then((response) => {
            if (response.status === 200) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchPublicQuestionnaires () {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/dabg/v1/questionnaires/public')
          .then((response) => {
            if (response.status === 200) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchQuestionnaire (id) {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/dabg/v1/questionnaires/' + id)
          .then((response) => {
            if (response.status === 200) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    voteOnQuestionnaire (id, answers) {
      return new Promise((resolve, reject) => {
        axios.post('/wp-json/dabg/v1/questionnaires/' + id + '/vote', { questions: answers })
          .then((response) => {
            if (response.status === 204) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    getResults (id) {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/dabg/v1/questionnaires/' + id + '/results')
          .then((response) => {
            if (response.status === 200) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    getUser (id) {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/dabg/v1/users/' + id)
          .then((response) => {
            if (response.status === 200) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchCampaigns () {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/wp/v2/campaigns')
          .then((response) => {
            if (response.status === 200) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchNCCampaigns (ncCatId) {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/wp/v2/campaigns?categories[]=' + ncCatId)
          .then((response) => {
            if (response.status === 200) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchNCCampaign (slug, ncCatId) {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/wp/v2/campaigns?slug=' + slug + '&categories=' + ncCatId)
          .then((response) => {
            if (response.status === 200 && response.data.length > 0) {
              resolve(response.data[0])
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchCampaign (slug) {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/wp/v2/campaigns?slug=' + slug)
          .then((response) => {
            if (response.status === 200 && response.data.length > 0) {
              resolve(response.data[0])
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchCities () {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/wp/v2/city', { params: { hide_empty: true } })
          .then((response) => {
            if (response.status === 200) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchEvents ({ scope, page, city }) {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/wp/v2/events', { params: { scope, per_page: 12, page, city } })
          .then((response) => {
            if (response.status === 200) {
              resolve({
                events: response.data,
                pages: parseInt(response.headers['x-wp-totalpages'])
              })
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchEvent (slug) {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/wp/v2/events?slug=' + slug)
          .then((response) => {
            if (response.status === 200 && response.data.length > 0) {
              resolve(response.data[0])
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    checkInUser (eventId, username, representedBy = false) {
      let data = { username }
      if (representedBy !== false) {
        data['represented_by'] = representedBy
      }

      return axios.post('/wp-json/wp/v2/events/' + eventId + '/checkin', data)
    },

    fetchElections () {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/wp/v2/elections')
          .then((response) => {
            if (response.status === 200) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchElection (slug) {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/wp/v2/elections?slug=' + slug)
          .then((response) => {
            if (response.status === 200 && response.data.length > 0) {
              resolve(response.data[0])
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchCurrentElection () {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/wp/v2/elections/current')
          .then((response) => {
            if (response.status === 200) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    checkOwnRegistrationFor (id) {
      return axios.get('/wp-json/wp/v2/elections/' + id + '/registration/me')
    },

    fetchProvinces () {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/dabg/v1/populated_places/provinces')
          .then((response) => {
            if (response.status === 200) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchPlacesInProvince (province) {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/dabg/v1/populated_places/provinces/' + province)
          .then((response) => {
            if (response.status === 200) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    registerUserForElection (user, electionID) {
      return axios.post('/wp-json/wp/v2/elections/' + electionID + '/registration', user)
    },

    confirmElectionRegistration (electionID, token) {
      return axios.post('/wp-json/wp/v2/elections/' + electionID + '/registration/confirm', { token })
    },

    getPublicKey (key) {
      return axios.get('/wp-json/dabg/v1/public_keys/' + key)
    },

    uploadOwnPublicKey (key) {
      return axios.post('/wp-json/dabg/v1/public_keys/', { key })
    },

    vote (vote) {
      return axios.post('/wp-json/dabg/v1/votes', vote)
    },

    getOwnVote (electionId) {
      return axios.get(`/wp-json/dabg/v1/votes/${electionId}/own`)
    },

    fetchNews ({ page, ids }) {
      const params = {
        page,
        include: ids,
        per_page: 12
      }

      return new Promise((resolve, reject) => {
        axios.get('/wp-json/wp/v2/posts', { params })
          .then((response) => {
            if (response.status === 200) {
              resolve({
                news: response.data,
                pages: parseInt(response.headers['x-wp-totalpages'])
              })
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchNCCampaignNews (fetchIds, ncCatId) {
      const includeIds = fetchIds !== false ? '?include=' + fetchIds.join(',') : ''

      return new Promise((resolve, reject) => {
        axios.get(urljoin('/wp-json/wp/v2/posts' + includeIds + '&categories=' + ncCatId))
          .then((response) => {
            if (response.status === 200) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchArticle (slug) {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/wp/v2/posts?slug=' + slug)
          .then((response) => {
            if (response.status === 200 && response.data.length > 0) {
              resolve(response.data[0])
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchPage (slug) {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/wp/v2/pages?slug=' + slug)
          .then((response) => {
            if (response.status === 200 && response.data.length > 0) {
              resolve(response.data[0])
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    fetchNCArticle (slug, ncCatId) {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/wp/v2/posts?slug=' + slug + '&categories=' + ncCatId)
          .then((response) => {
            if (response.status === 200 && response.data.length > 0) {
              resolve(response.data[0])
            } else {
              reject(response)
            }
          })
          .catch(error => reject(error))
      })
    },

    getTokenFor (username, password) {
      return new Promise((resolve, reject) => {
        axios.post('/wp-json/jwt-auth/v1/token', { username, password })
          .then((response) => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },

    verifyToken () {
      return new Promise((resolve, reject) => {
        axios.post('/wp-json/jwt-auth/v1/token/validate')
          .then((response) => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },

    registerUser (user) {
      return new Promise((resolve, reject) => {
        axios.post('/wp-json/dabg/v1/users', user)
          .then((response) => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },

    updateUser (user) {
      return new Promise((resolve, reject) => {
        axios.put('/wp-json/dabg/v1/users/me', user)
          .then((response) => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },

    removeUser () {
      return new Promise((resolve, reject) => {
        axios.delete('/wp-json/dabg/v1/users/me')
          .then((response) => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },

    resetPassword (email) {
      return new Promise((resolve, reject) => {
        axios.post('/wp-json/dabg/v1/users/reset-password/' + email)
          .then((response) => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },

    updatePassword (userID, token, password) {
      return new Promise((resolve, reject) => {
        axios.put('/wp-json/dabg/v1/users/' + userID + '/password', { token, password })
          .then((response) => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },

    postForm (formId, data) {
      const url = `/wp-json/contact-form-7/v1/contact-forms/${formId}/feedback`
      const config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      return axios.post(url, data, config)
    },

    fetchLocalOrganizations () {
      return axios.get('/wp-json/wp/v2/local_organization')
    }
  }
}
